import { TEventBus } from '@eventBus/EventBus';

export class EWMA {
  public _eventBus: TEventBus;
  private _previousFastValue: number | null = null;
  private _previousSlowValue: number | null = null;

  private readonly _fastAlpha: number;
  private readonly _slowAlpha: number;

  constructor(fastAlpha: number, slowAlpha: number, eventBus: TEventBus) {
    this._eventBus = eventBus;
    this._fastAlpha = fastAlpha;
    this._slowAlpha = slowAlpha;
  }

  public addValue(value: number): void {
    const { _fastAlpha, _slowAlpha } = this;
    this._previousFastValue = _fastAlpha * value + (1 - _fastAlpha) * (this._previousFastValue || value);
    this._previousSlowValue = _slowAlpha * value + (1 - _slowAlpha) * (this._previousSlowValue || value);

    this._eventBus.publish('EWMAMetrics', { fast: this._previousFastValue, slow: this._previousSlowValue });
  }

  public getCurrentValue(): number {
    if (!this._previousSlowValue || !this._previousFastValue) {
      return 0;
    }

    return Math.min(this._previousFastValue, this._previousSlowValue);
  }

  getCurrentMaximalValue(): number {
    if (!this._previousFastValue || !this._previousSlowValue) {
      return 0;
    }

    return Math.max(this._previousSlowValue, this._previousFastValue);
  }

  public reset(): void {
    this._previousSlowValue = null;
    this._previousFastValue = null;
  }
}
